<template>
  <v-app>
<!--    <v-app-bar-->
<!--      app-->
<!--      color="primary"-->
<!--      dark-->
<!--    >-->

<!--    </v-app-bar>-->

    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  data: () => ({

  }),
  computed:{
    type: {
      get() {
        return this.$store.state.type;
      },
      set(val) {
        this.$store.state.type = val;
      }
    },

    weekday: {
      get() {
        return this.$store.state.weekday;
      },
      set(val) {
        this.$store.state.weekday = val;
      }
    }
  } 
};
</script>
